import logIt from "../../../logIt";
import Utils from "../Utils";
import Browser from "./Browser";
import ChatFlowEnableFlag from "./ChatFlowEnableFlag";
import removeValidationTooltip from "./removeValidationTooltip";
import setPlaceholder from "./setPlaceholder";
import focusInput from "./focusInput";

const disableTypingInput = (me, inputContainerSelector, instruction) => {
    // CHAT-7038: disable input
    if (!inputContainerSelector) return;
    const isScriptBot = (options) =>
        options &&
        (options.scriptBotEnabled ||
            (options.chatModel && options.chatModel.scriptBotEnabled) ||
            (options.model && options.model.scriptBotEnabled));
    var input = typeof inputContainerSelector === 'string' ? me.context.querySelector(inputContainerSelector) : inputContainerSelector
    const textAreaExists = input.getElementsByTagName('textarea')[0]; // check text area exists or not
    const autoSendScriptMessage =
        me.options.autoSendScriptMessage || me.options.model?.autoSendScriptMessage;
    logIt('QTEXT:: input field is disabled now.');
    if ((Browser.isAndroid() || Browser.isiOS())) {
        removeValidationTooltip(input, { toolTipCss: 'livechat_validation_tooltip' })
        Utils.disableElement(input, { applyGrayBackground: true });
        //Utils.preventTyping(input);
        if (textAreaExists) {
            textAreaExists.classList.add('livechat_disabledcaret');
        }
    } else if (
        me.options &&
        (autoSendScriptMessage === ChatFlowEnableFlag.Auto_Send || isScriptBot(me.options))) {
        removeValidationTooltip(input, { toolTipCss: 'livechat_validation_tooltip' })
        Utils.disableElement(input, { applyGrayBackground: true })
        if (input) {
            input.removeEventListener('click', focusInput);
        }
        if (textAreaExists) {
            input = textAreaExists;
        }
        Utils.disableElement(input).blur();
    }
    if (instruction) {
        setPlaceholder(input, instruction);
    }
};
export default disableTypingInput;